// src/components/CommentCitationSystem.js
import React, { useState, useEffect } from 'react';
import { deleteComment, subscribeToComments } from '../firebase/comments';
import CommentForm from './CommentForm';
import CommentTable from './CommentTable';
import CitationTable from './CitationTable';

const CommentCitationSystem = ({ user }) => {
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Subscribe to comments when component mounts
  useEffect(() => {
    let unsubscribe = () => {};
    
    if (user) {
      setIsLoading(true);
      unsubscribe = subscribeToComments((commentsData) => {
        setEntries(commentsData);
        setIsLoading(false);
      });
    } else {
      setEntries([]);
      setIsLoading(false);
    }
    
    // Cleanup subscription when component unmounts
    return () => unsubscribe();
  }, [user]);
  
  const handleError = (errorMessage) => {
    setError(errorMessage);
    // Auto-dismiss error after 5 seconds
    setTimeout(() => {
      setError(null);
    }, 5000);
  };
  
  // Separate comments and citations
  const comments = entries.filter(entry => !entry.isCitation);
  const citations = entries.filter(entry => entry.isCitation);
  
  if (!user) {
    return (
      <div className="comment-citation-system">
        <div className="sign-in-prompt">
          <p>Please sign in to view and participate in discussions</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="comment-citation-system">
      {error && (
        <div className="error-banner">
          {error}
          <button 
            className="close-button" 
            onClick={() => setError(null)}
          >
            ×
          </button>
        </div>
      )}
      
      <CommentForm 
        user={user} 
        onError={handleError} 
      />
      
      <CommentTable 
        entries={comments} 
        onDeleteEntry={(entryId) => deleteComment(entryId)}
        isLoading={isLoading}
        user={user}
        onError={handleError}
      />
      
      <CitationTable 
        entries={citations} 
        onDeleteEntry={(entryId) => deleteComment(entryId)}
        isLoading={isLoading}
        user={user}
        onError={handleError}
      />
    </div>
  );
};

export default CommentCitationSystem;